export default __webpack_public_path__ + "static/364086_0_0-cd49e702aa8cac9099dd8f6b58b39e93.woff";